import { render, staticRenderFns } from "./Playbooks.vue?vue&type=template&id=12e1a0f1&"
import script from "./Playbooks.vue?vue&type=script&lang=js&"
export * from "./Playbooks.vue?vue&type=script&lang=js&"
import style0 from "./Playbooks.vue?vue&type=style&index=0&id=12e1a0f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports